import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import SupplierDiscountService from "../../Controller/SupplierDiscountController";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import StockCategoryService from "../../../Setup/controller/StockCategoryController/StockCategoryController";
import { handleChange, handleSubmit } from "../../Controller/CreateSupplierDiscountController";
import Swal from 'sweetalert2';
import HelpSite from "../../../Common/HelpLink";
function CreateSupplierDiscount({ SupplierID }) {

    const navigate = useNavigate();

    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        ID: 0,
        FK_Supplier_ID: SupplierID,
        FK_StockCategory_ID: 0,
        FK_DiscountType_ID: 0,
        dec_Amount: "0.00"
    });
    const [DiscountTypeList, setDiscountTypeData] = useState([]);
    const [DiscountsList, setDiscounts] = useState([]);

    const { theme } = useContext(ThemeContext);
    const resetForm = async () => {
        setFormData({
            ID: 0,
            FK_StockCategory_ID: 0,
            FK_DiscountType_ID: 0,
            dec_Amount: "0.00"
        });
    };
    const fetchSupplierDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const data = await SupplierDiscountService.GetAllSupplierDiscounts(redirectCallback, SupplierID);
            debugger;
            if (data.length > 0) {
                setFormData({
                    ID: data[0].PK_SupplierCategory_ID,
                    FK_Supplier_ID: SupplierID,
                    FK_StockCategory_ID: data[0].FK_StockCategory_ID,
                    FK_DiscountType_ID: data[0].FK_DiscountType_ID,
                    dec_Amount: data[0].dec_Amount,

                });
            }
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        }
    };

    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const fetchDiscountType = async () => {
        try {
            debugger;
            const redirectCallback = () => navigate('/');
            const data = await StockCategoryService.GetAllStckCategories(redirectCallback);
            setDiscountTypeData(data);
        } catch (error) {
            console.error('Error fetching discount types:', error);
        }
    };
    useEffect(() => {
        fetchSupplierDiscount();
        fetchDiscount();
        fetchDiscountType();
    }, [SupplierID]);

    const handleFieldChange = (event) => {
        const { name, value } = event.target;

        // Update formData directly, applying conditional logic for FK_StockCategory_ID
        setFormData((prevFormData) => {
            const updatedFormData = {
                ...prevFormData,
                [name]: value,
                ...(name === 'FK_StockCategory_ID' && value === '0' ?
                    { FK_DiscountType_ID: 0, dec_Amount: '0.00' } : {})
            };
            return updatedFormData;
        });
    };
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        formData.FK_Supplier_ID = SupplierID;
        const postData = await handleSubmit(event, formData, setFormData, setErrors);
        if (postData) {
            if (postData.message === "User added successfully") {
                await resetForm();
                await fetchSupplierDiscount();
                Swal.fire(
                    'Success!',
                    'Date saved successfully.',
                    'success'
                );
            }
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');
    return (
        <div>

            <form onSubmit={handleFormSubmit}>
                <div className="row mb-3" style={{ marginLeft: "-5px" }}>
                    <div className="col-sm-12">
                        <table style={{ width: "100%" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "13%" }}> <label htmlFor="FK_StockCategory_ID" style={{float:"right"}}>Category <span style={{ "color": "red" }}>*</span></label></td>
                                    <td style={{ width: "37%" }}>
                                        <select name="FK_StockCategory_ID" className='form-control' value={formData.FK_StockCategory_ID} onChange={handleFieldChange}>
                                            <option value="0">Select Category</option>
                                            {DiscountTypeList.map((discount) => (
                                                <option key={discount.PK_StockCategory_ID} value={discount.PK_StockCategory_ID}>
                                                    {discount.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.FK_StockCategory_ID && <div style={{ color: 'red' }}>{errors.FK_StockCategory_ID}</div>}
                                    </td>

                                    <td style={{ width: "13%" }}> <label htmlFor="FK_DiscountType_ID" style={{float:"right"}}>Discount Type <span style={{ "color": "red" }}>*</span></label></td>
                                    <td style={{ width: "37%" }}>
                                        <select name="FK_DiscountType_ID" className='form-control' value={formData.FK_DiscountType_ID} onChange={handleFieldChange} disabled={formData.FK_StockCategory_ID === '0'}>
                                            <option value="0">Select Discount Type</option>
                                            {DiscountsList.map((discount) => (
                                                <option key={discount.PK_DiscountType_ID} value={discount.PK_DiscountType_ID}>
                                                    {discount.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.FK_DiscountType_ID && <div style={{ color: 'red' }}>{errors.FK_DiscountType_ID}</div>}
                                    </td>
                                </tr>
                                <tr>

                                    <td> <label htmlFor="dec_Amount" style={{float:"right"}}>Amount &nbsp;&nbsp;</label></td>
                                    <td>
                                        <input type="text" className="form-control" name="dec_Amount" value={formData.dec_Amount} onChange={handleFieldChange} disabled={formData.FK_StockCategory_ID === '0'} />
                                        {errors.dec_Amount && <div style={{ color: 'red' }}>{errors.dec_Amount}</div>}
                                    </td>
                                    <td></td>
                                    <td></td>

                                </tr>
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td style={{ float: "right" }}>
                                        <button type="submit" className={`btn btn-primary ${localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`}>
                                            <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />
                                                Save
                                            
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </form>


        </div>


    );
}
export default CreateSupplierDiscount;

